import { useLayoutEffect, useContext } from 'react';
import { ReduxContext } from '../Context/ReduxContext';
export function useDynamicReducer(reducerName, reducer, sagas = [], shouldPersist = true) {
    const { reducerRegistry, runSaga } = useContext(ReduxContext);
    useLayoutEffect(() => {
        if (!reducerRegistry.exists(reducerName)) {
            const skipIfExists = true;
            reducerRegistry.registerDynamic(reducerName, reducer, skipIfExists, shouldPersist);
            sagas.map((saga) => runSaga(saga));
        }
    }, [reducer, reducerName, reducerRegistry, runSaga, sagas, shouldPersist]);
}
//# sourceMappingURL=useDynamicReducer.js.map